import { Box } from "@mui/material";
import { useContext, useState } from "react";
import { Input, PromiseLoader } from "react-builder";
import { SubmitHandler, useForm } from "react-hook-form";
import { MoonLoader } from "react-spinners";
import { ProductServerAuthContext } from "../providers/ProductServerAuth";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IResetPasswordData {
  password: string;
  passwordConfirmation: string;
}

export const ResetPasswordForm = () => {
  const {
    isLoggedIn,
    isLoginDialogOpen,
    setLoginDialogOpen,
    login,
    logout,
    loginError,
    resetPassword,
    getSession,
  } = useContext(ProductServerAuthContext);
  const query = new URLSearchParams(window.location.search);
  const token = getSession()?.token ?? query.get("token") ?? query.get("resetToken");

  const formSchema = Yup.object().shape({
    password: Yup.string().required("Password is required"),
    passwordConfirmation: Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
  const formOptions = { resolver: yupResolver(formSchema) };
  const { register, watch, formState, handleSubmit } = useForm<IResetPasswordData>(formOptions);
  const [error, setError] = useState<string>();

  const [loginPromise, setLoginPromise] = useState<Promise<any> | undefined>(undefined);

  const onSubmit: SubmitHandler<IResetPasswordData> = (data: IResetPasswordData) => {
    console.log("reset password");

    if (!token) {
      setError("Invalid link, please try again");
    } else {
      setLoginPromise(
        resetPassword(token, data.password).then((success) => {
          handleClose();
          return success;
        })
      );
    }
  };

  const handleClose = () => {
    setLoginDialogOpen(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="login-form" noValidate>
      <PromiseLoader<any>
        promise={loginPromise}
        loader={<MoonLoader loading={true} size={20} />}
        overlayColor="rgba(255,255,255,.4)"
      >
        {(res) =>
          res ? (
            <p>{res.message}</p>
          ) : (
            <>
              <Box
                component="div"
                sx={{
                  "& .MuiTextField-root": { m: 5, width: "25ch" },
                }}
              >
                <Input
                  register={register}
                  label="New password"
                  name="password"
                  type="password"
                  error={formState.errors.password}
                ></Input>
                <Input
                  register={register}
                  label="Confirm new password"
                  name="passwordConfirmation"
                  type="password"
                  error={formState.errors.passwordConfirmation}
                ></Input>
              </Box>
              <button className="submit-button" type="submit" autoFocus>
                Continue
              </button>
              <p className="input-error">{error}</p>
            </>
          )
        }
      </PromiseLoader>
    </form>
  );
};
